import React, { useCallback } from "react";
import {
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Row,
  Col,
  Switch,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomers } from "../../store/actions/customers";
import { getAllSettings } from "../../store/actions/settings";
import { STORAGE_TYPE, RAM_TYPE } from "../../constants/data";

const ItemForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const customers = useSelector((state) => state.customers.list);
  const settings = useSelector((state) => state.settings.list);

  const handleValuesChange = useCallback(
    (changedValues, allValues) => {
      if (allValues && allValues.type) {
        dispatch(getAllSettings());
      }
      if (allValues.type) {
        const setting =
          Array.isArray(settings) && settings.length > 0 ? settings[0] : null;
        if (allValues) {
          const rate =
            allValues.type === "EWAY"
              ? setting?.ewayRatePerPcs
              : setting?.eInvoiceRatePerPcs;
          form.setFieldValue("ratePerPcs", rate);
        }
      }
      form.setFieldValue(
        "amt",
        Number(allValues?.count || 0) * Number(allValues?.ratePerPcs || 0)
      );
    },
    [form, dispatch, settings]
  );

  useEffect(() => {
    if (record?.id) {
      const formattedValues = {
        ...record,
        battery: record?.battery ? Number(record.battery) : undefined,
        height: record?.height ? Number(record.height) : undefined,
        length: record?.length ? Number(record.length) : undefined,
        weight: record?.weight ? Number(record.weight) : undefined,
      };

      form.setFieldsValue(formattedValues);
    } else {
      form.resetFields();
    }
  }, [form, record, record?.id]);

  useEffect(() => {
    dispatch(getCustomers());
  }, [dispatch]);

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Modal
      open={visible}
      title={record ? "Update Item" : "Add Item"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            console.log("Data For Save:", values);
            if (record?.id) delete values.isForAll;
            onCreate(values);
            form.resetFields();
            onCancel();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
      width={800}
      centered
      bodyStyle={{ paddingTop: 20 }}
    >
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        name="eWayTransaction_form"
        onValuesChange={handleValuesChange}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please enter the name!",
                },
              ]}
            >
              <Input
                placeholder="Enter name"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="weight"
              label="Weight"
              rules={[
                { type: "number", message: "Must be a valid Weight!" },
              ]}
            >
              <InputNumber
                placeholder="Enter weight"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="length"
              label="Length"
              rules={[
                { type: "number", message: "Must be a valid Length!" },
              ]}
            >
              <InputNumber
                placeholder="Enter length"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="height"
              label="Height"
              rules={[
                { type: "number", message: "Must be a valid Height!" },
              ]}
            >
              <InputNumber
                placeholder="Enter height"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="display"
              label="Display"
            >
              <Input
                placeholder="Enter display"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="displayType"
              label="Display Type"
            >
              <Input
                placeholder="Enter Display Type"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="frontCamera"
              label="Front Camera"
            >
              <Input
                placeholder="Enter Front Camera"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="rearCamera"
              label="Rear Camera"
            >
              <Input
                placeholder="Enter Rear Camera"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="processor"
              label="Processor"
            >
              <Input
                placeholder="Enter Processor"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="mmSize"
              label="MM Size"
            >
              <Input
                placeholder="Enter MM Size"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="ram"
              label="Ram"
            >
              <Select
                placeholder="Select Ram"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {RAM_TYPE?.map((c) => (
                  <Select.Option key={c.id} value={c.id}>
                    {c.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="storage"
              label="Storage"
            >
              <Select
                placeholder="Select Storage"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {STORAGE_TYPE?.map((c) => (
                  <Select.Option key={c.id} value={c.id}>
                    {c.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="battery"
              label="Battery"
              rules={[
                { type: "number", message: "Must be a valid Battery!" },
              ]}
            >
              <InputNumber
                placeholder="Enter Battery"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          {!record?.id ? (
            <Col span={8}>
              <Form.Item
                name="isForAll"
                label={
                  <span>
                    Add For All{" "}
                    <Tooltip title="If enabled, this item will be added for all database records.">
                      <InfoCircleOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                    </Tooltip>
                  </span>
                }
              >
                <Switch />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      </Form>
    </Modal>
  );
};

export default ItemForm;
